class BreakpointHelpers {
  constructor () {
    this.winWidth = $(window).width()
    this.breakpoints = {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    }

    this.lastScreen = { width: null, breakpoint: null }
    this.currentScreen = { width: null, breakpoint: null }

    $(window).on('load resize', (event) => {
      this.winWidth = window.innerWidth

      this.currentScreen.width = window.innerWidth
      this.currentScreen.breakpoint = this.determineBreakpoint(this.currentScreen.width)

      if (this.lastScreen.breakpoint !== this.currentScreen.breakpoint) {
        /*
          * trigger custom event when we're changing a breakpoint.
          * pass the old and the new breakpoint names as params to the
          * custom event
          */
        $(window).trigger('breakpointChange', [this.lastScreen.breakpoint, this.currentScreen.breakpoint])
      }

      // Set the last screen object attributes
      this.lastScreen.width = this.currentScreen.width
      this.lastScreen.breakpoint = this.currentScreen.breakpoint
    })
  }

  /**
   * Determines on which breakpoint our screen is.
   *
   * @param int width
   * @return string the key of the `breakpoints` object
   */
  determineBreakpoint (width) {
    let bp

    $.each(this.breakpoints, function (bpName, bpWidth) {
      if (width >= bpWidth) {
        bp = bpName
      }
    })

    return bp
  }

  /**
   * Determines whether we are at least on a specific device screen.
   *
   * @param string device
   */
  isScreenAtLeast (device) {
    return this.winWidth >= this.breakpoints[device]
  };

  /**
   * Determines whether we are exactly on a specific device screen.
   *
   * @param string device
   */
  isScreenBetween (deviceMin, deviceMax) {
    return this.winWidth >= this.breakpoints[deviceMin] && this.winWidth < this.breakpoints[deviceMax]
  };
}

export default BreakpointHelpers



// WEBPACK FOOTER //
// ./scripts/util/breakpointHelpers.js